import selectloadmore from './select-loadmore/loadmore';
import loadmore from './loadmore';
export default {
  loadmore,
  selectloadmore,
};
